import {CITIES_GET_ERROR, CITIES_GET_REQUESTING, CITIES_GET_SUCCESS} from "./constants";

export const citiesGetRequesting = () => ({
    type: CITIES_GET_REQUESTING,
});

export const citiesGetSuccess = (cities) => ({
    type: CITIES_GET_SUCCESS,
    cities,
});

export const citiesGetError = (error) => ({
    type: CITIES_GET_ERROR,
    error,
});